import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const SyncIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M13.7071 0.892899C14.0976 1.28342 14.0976 1.91659 13.7071 2.30711L13.4103 2.60396C17.9882 3.28523 21.5 7.2325 21.5 12C21.5 15.1587 19.9574 17.9572 17.5889 19.6828C17.1425 20.0081 16.517 19.9098 16.1918 19.4635C15.8665 19.0171 15.9648 18.3916 16.4111 18.0664C18.2853 16.701 19.5 14.4924 19.5 12C19.5 8.3558 16.9009 5.31864 13.4553 4.6411L13.7071 4.8929C14.0976 5.28342 14.0976 5.91659 13.7071 6.30711C13.3166 6.69764 12.6834 6.69764 12.2929 6.30711L10.2929 4.30711C9.90237 3.91659 9.90237 3.28342 10.2929 2.8929L12.2929 0.892899C12.6834 0.502375 13.3166 0.502375 13.7071 0.892899ZM7.80824 4.53655C8.13345 4.98293 8.03523 5.60843 7.58886 5.93364C5.71475 7.29905 4.5 9.50762 4.5 12C4.5 15.6442 7.09909 18.6814 10.5447 19.3589L10.2929 19.1071C9.90237 18.7166 9.90237 18.0834 10.2929 17.6929C10.6834 17.3024 11.3166 17.3024 11.7071 17.6929L13.7071 19.6929C14.0976 20.0834 14.0976 20.7166 13.7071 21.1071L11.7071 23.1071C11.3166 23.4976 10.6834 23.4976 10.2929 23.1071C9.90237 22.7166 9.90237 22.0834 10.2929 21.6929L10.5897 21.396C6.01184 20.7148 2.5 16.7675 2.5 12C2.5 8.84132 4.04258 6.04282 6.41114 4.31717C6.85752 3.99195 7.48302 4.09017 7.80824 4.53655Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

SyncIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(SyncIcon);
